import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";
import { DraftMessageId, MessageId } from "../ids/definitions";
import { Attachment } from "../models/shopper-ai/conversation/message/attachment";

const GetMessageAttachmentsResponse = Schema.Struct({
  messageId: MessageId,
  attachments: Schema.Array(Attachment),
});

const GetDraftMessageAttachmentsResponse = Schema.Struct({
  draftMessageId: DraftMessageId,
  attachments: Schema.Array(Attachment),
});

const AddDraftAttachmentRequest = Schema.Struct({
  draftMessageId: DraftMessageId,
  file: Schema.String,
  filename: Schema.String,
  mimeType: Schema.String,
  size: Schema.Number,
});

const AddDraftAttachmentResponse = Schema.Struct({
  attachment: Attachment,
  draftMessageId: DraftMessageId,
});

export const AttachmentGroup = HttpApiGroup.make("attachment")
  .add(
    HttpApiEndpoint.get(
      "getMessageAttachments",
      "/messages/:messageId/attachments",
    )
      .middleware(Authorization)
      .setPath(Schema.Struct({ messageId: MessageId }))
      .addSuccess(GetMessageAttachmentsResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.get(
      "getDraftMessageAttachments",
      "/draft-messages/:draftMessageId/attachments",
    )
      .middleware(Authorization)
      .setPath(Schema.Struct({ draftMessageId: DraftMessageId }))
      .addSuccess(GetDraftMessageAttachmentsResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.post("addDraftAttachment", "/draft-attachments")
      .middleware(Authorization)
      .setPayload(AddDraftAttachmentRequest)
      .addSuccess(AddDraftAttachmentResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
